<script lang="ts">
  import { checkSchedule } from "@shared/common/domain/schedule";
  import {
    getCardWrapperLayoutStyle,
    getCardWrapperStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type { ICardWrapperNode, PartialNode } from "@shared/common/node/type";
  import type {
    IPartialCampaignListData,
    IPartialCampaignListDataItem,
  } from "@shared/common/types/data-source";
  import { getStore } from "../../context";
  import CardImage from "./card-image.svelte";
  import CardPPT from "./card-ppt.svelte";

  const { dataMap, device } = getStore();
  export let node: PartialNode<ICardWrapperNode>;

  const campaignList = $dataMap["campaign_list"] as
    | IPartialCampaignListData
    | undefined;
  const campaigns = campaignList?.data?.campaigns || [];
  const orderedCampaigns = campaigns.sort((a, b) => b.order - a.order);
  const filteredCampaigns = orderedCampaigns.filter((item) => {
    const result =
      item.schedule && $device
        ? checkSchedule({
            currentDate: new Date(),
            schedule: item.schedule,
            currentDevice: $device,
          })
        : { type: "IGNORE" };
    return result.type === "FAIL" ? false : true;
  });
  let ref: HTMLDivElement;

  /** TODO: sdk-js로 이동? */
  function getLink(item: IPartialCampaignListDataItem) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("cbdetail", item.publicId);
    return newUrl.href;
  }

  /** TODO: sdk-js로 이동? */
  function handleItemClick(e: MouseEvent, item: IPartialCampaignListDataItem) {
    e.preventDefault();
    window.history.pushState({}, "", getLink(item));
    const shadowRoot = ref.getRootNode() as ShadowRoot | undefined;
    shadowRoot?.host?.scrollIntoView({ behavior: "instant" });
  }
</script>

<div style={styleToString(getCardWrapperStyle(node))} bind:this={ref}>
  <div style={styleToString(getCardWrapperLayoutStyle(node.layout))}>
    {#each filteredCampaigns as item, idx}
      <a on:click={(e) => handleItemClick(e, item)} href={getLink(item)}>
        {#if node.card?.type === "PPT"}
          <CardPPT card={node.card} {idx} content={item.content} />
        {:else if node.card?.type === "IMAGE"}
          <CardImage card={node.card} content={item.content} />
        {/if}
      </a>
    {/each}
  </div>
</div>
